<template>
    <div id='collage'>
        <div class='d-flex flex-column'>
            <div class='d-flex group' v-for="row in rows" :key="row" style=''>
                <div class='image' 
                    :id="idFor(row, col)"
                    v-for="col in rowItemCount" 
                    :key="col" 
                    v-bind:style="itemStyle(row, col)"/>
            </div>
        </div>
    </div>
</template>

<script>
import images from "../../data/images";
import { setTimeout, setInterval, clearTimeout } from 'timers';
import JQuery from 'jquery'

let $ = JQuery

export default {
    name: 'collage',

    data () {
        return {
            width: 0,
            height: 0,
            polling: null
        }
    },

    created() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
        
        if(this.polling) 
            clearTimeout(this.polling);

        this.polling = setInterval(this.highlight, 3000);
        setTimeout(this.highlight, 300); // RUN ONE RIGHT AWAY
    },

    computed: {
        itemWidth () { return this.width / this.rowItemCount },
        rowItemCount() {return this.width > 700 ? 6 : 2},
        rows() {return this.width > 700 ? 4 : 6}
    },

    methods: {
        handleResize() {
            this.width = window.innerWidth;
            this.height = window.innerHeight;
        },

        itemStyle(i, j) {
            return {
                'flexGrow': 1,
                backgroundImage: 'url('+ images[ (i * this.rowItemCount) + j] +')'
            }
        },

        highlight(){
            let row = (Math.random() * (this.rows - 1) | 0) + 1
            let col = (Math.random() * (this.rowItemCount) | 0) + 1
            $("#collage .highlight").removeClass('highlight');
            let e = $("#" + this.idFor(row, col)).addClass('highlight');
        },

        idFor (row, col) { return ["item", row, col].join("-") }
    }
}
</script>

<style lang="scss" scoped>
    #collage {position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden;}
    #collage > div {height: 100%;}
    .group {flex-grow: 1; align-items: stretch}
    div.image {opacity: 0.1; background-size: cover; background-position: center; transition: opacity 2s; border: 0}
    div.image.highlight {opacity: 0.8; }
</style>